<template>
  <div style="background-color: #fff;height: 100%;">
    <div style="padding: 20px;">

      <div>
        <el-row v-show="!disabled">
          <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
        </el-row>
        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>
      <div>
        <template>
          <el-table
            :data="tableData"
            :height="th"
            border
            style="width: 100%;"
          >
            <el-table-column prop="drugName" label="药名"></el-table-column>
            <el-table-column :formatter="timefilter" prop="beginTime" label="服药日期"></el-table-column>
            <el-table-column prop="takeMethod" label="使用方法"></el-table-column>
            <el-table-column prop="dosage" label="用药剂量"></el-table-column>
            <el-table-column prop="treatment" label="服用疗程"></el-table-column>
            <el-table-column prop="remarks" label="作用"></el-table-column>
          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div
              style="float: left;padding: 5px;"
            >共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change"
              ></el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>
    <MedicalRecordsAdd ref="myMedicalRecordsAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></MedicalRecordsAdd>
  </div>
</template>

<script>
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import MedicalRecordsAdd from "./MedicalRecordsAdd";

export default {
  name: "Role",
  data() {
    return {
      showModalAdd: false,
      disabled: false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: this.$store.state.tableHeight-100,
      userCode: "",
      elderlyCode: "",
      drugName: "",
      beginTime: "",
      takeMetdhod: "",
      dosage: "",
      treatment: "",
      remarks: "",
    };
  },
  created() {
    this.th = this.$store.state.tableHeight-90;
  },
  components: {
    MedicalRecordsAdd
  },
  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
        this.th = val-90;
    },
    disabled(val){
      this.th = this.$store.state.tableHeight-(val?50:100);
    }
  },
  methods: {
      init(flag,row,disabled) {
      if(disabled)this.disabled=disabled
        flag=true;
        this.elderlyCode=row.elderlyCode;
        this.userCode=row.userCode;
        this.getList();
    },
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myMedicalRecordsAdd.init(this.elderlyCode,this.userCode);
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(flag) {
      if(flag)this.currentPage=1
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ETakeDrugs/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          elderlyCode: this.elderlyCode,
          userCode: this.userCode,
          pageSize: this.pageSize,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue).substring(0,11)
            },
  },
};
</script>

<style scoped>
</style>
